(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/middlewares/socket-middleware.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/middlewares/socket-middleware.js');

'use strict';

const {
  subscribe,
  unsubscribe
} = svs.core.socket;
const {
  drawsApi
} = svs.numbergames.draws;
const {
  containerStates
} = svs.numbergames.fractiongames.constants;
const {
  ACTION_TYPES
} = svs.numbergames.fractiongames.redux;
const {
  actions
} = svs.numbergames.fractiongames.redux.slices.containers;
const {
  hasPassedGenereateEndTime
} = svs.numbergames.fractiongames.utils;
const missingInUpdates = new Map();
function getSocketUpdateHandler(store) {
  const getContainers = () => store.getState().containers;
  const containerAdded = update => store.dispatch(actions.containerAdded(update));
  const gameGenerated = update => store.dispatch(actions.gameGenerated(update));
  const gameShareSold = update => store.dispatch(actions.gameShareSold(update));
  const containerClosed = containerId => store.dispatch(actions.containerClosed(containerId));
  const gameSoldOut = containerId => store.dispatch(actions.gameSoldOut(containerId));
  const containerRemoved = containerId => store.dispatch(actions.containerRemoved(containerId));
  return socketUpdate => {
    const updates = (socketUpdate === null || socketUpdate === void 0 ? void 0 : socketUpdate.drawUpdates) || [];
    const containers = getContainers();
    updates.forEach(update => {
      const container = containers[update.containerId];
      switch (true) {
        case !container:
          containerAdded(update);
          break;
        case container.activatedDrawId !== update.activatedDrawId:
          gameGenerated(update);
          break;
        case container.soldShares !== update.soldShares:
          gameShareSold(update);
          break;
        default:
      }
    });
    Object.values(containers).forEach(container => {
      const update = updates.find(update => update.containerId === container.containerId);
      if (update || container.containerState === containerStates.CONTAINER_CLOSED) {
        missingInUpdates.delete(container.containerId);
      }
      switch (true) {
        case Boolean(update):
          break;
        case container.containerState === containerStates.CONTAINER_CLOSED && !container.activatedDrawId:
          break;
        case container.containerState === containerStates.CONTAINER_CLOSED && Boolean(container.activatedDrawId):
          containerClosed(container.containerId);
          break;
        case container.soldShares === container.totalShares && hasPassedGenereateEndTime(container):
          containerClosed(container.containerId);
          break;
        default:
          if (!missingInUpdates.has(container.containerId)) {
            missingInUpdates.set(container.containerId, drawsApi.clientNow());
          }
          if (container.containerState === containerStates.CONTAINER_OPEN && container.soldShares === container.totalShares) {
            if (dateFns.differenceInSeconds(drawsApi.clientNow(), missingInUpdates.get(container.containerId)) >= 15) {
              gameSoldOut(container.containerId);
            }
          }
          if (container.containerState === containerStates.GAME_SOLD_OUT) {
            if (dateFns.differenceInMinutes(drawsApi.clientNow(), missingInUpdates.get(container.containerId)) >= 5) {
              missingInUpdates.delete(container.containerId);
              containerRemoved(container.containerId);
            }
          }
      }
    });
  };
}
const socketMiddleware = store => {
  const onMessage = getSocketUpdateHandler(store);
  return next => action => {
    switch (action.type) {
      case ACTION_TYPES.SOCKET_SUBSCRIBE:
        subscribe(action.path, onMessage, store, false);
        break;
      case ACTION_TYPES.SOCKET_UNSUBSCRIBE:
        unsubscribe(action.path, onMessage, store, false);
        break;
      default:
        return next(action);
    }
  };
};
svs.numbergames.fractiongames.redux.middlewares.socketMiddleware = socketMiddleware;

 })(window);